namespace $ {
	$mol_style_define($bog_quiz, {
		maxWidth: '60rem',
		margin: 'auto',
	})
}
